import { Controller } from "@hotwired/stimulus"
import Uppy from "@uppy/core";
import ky from 'ky';
import Dashboard from "@uppy/dashboard";
import Russian from "@uppy/locales/lib/ru_RU";
// import English from "@uppy/locales/lib/en_US";
import AwsS3Multipart from "@uppy/aws-s3-multipart";
// import XHRUpload from "@uppy/xhr-upload";
import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";

// Connects to data-controller="uppy"
export default class extends Controller {
  connect() {
    let companionUrl = `https://rentprog.net/clients/`
    if (document.querySelector('meta[name="environment"]').content == "development") {
      companionUrl = `http://localhost:3000/clients/`
    }
    const uppy = new Uppy({
      debug: true,
      locale: Russian,
      autoProceed: true,
      allowMultipleUploads: true,
      width: '100%',
      height: 100,
      restrictions: {
        maxFileSize: 1000000,
        minNumberOfFiles: 1,
        maxNumberOfFiles: 10,
        allowedFileTypes: [
          "image/*",
          ".heic",
          ".heif",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "application/pdf",
        ],
      },
    })
      .use(Dashboard, {
        hideUploadButton: true,
        theme: this.theme,
        inline: true,
        width: '100%',
        height: 150,
        target: this.element,
        replaceTargetContent: true,
        showProgressDetails: true,
        browserBackButtonClose: true,
        locale: {
          strings: {
            poweredBy2: "",
            browseFiles: "выберите файлы"
          },
        },
      })
      .use(AwsS3Multipart, {
        limit: 5,
        companionUrl: companionUrl,
      });
    uppy.on("complete", (event) => {
      event.successful.forEach((element) => {
        if (element !== undefined) {
          console.log(element.s3Multipart.key);
          let url = `https://rentprog.net/api/v1/vseprokaty_clients_documents`
          if (document.querySelector('meta[name="environment"]').content == "development") {
            url = `http://localhost:3000/api/v1/vseprokaty_clients_documents`
          }
          try {
            const response = ky.post(url, {
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': document.querySelector('meta[name="crfs-token"]').content
              },
              json: {
                clients_files: {
                  client_id: this.element.dataset.clientId,
                  name: `${element.s3Multipart.key}`,
                  url: `https://rentprog.storage.yandexcloud.net/${element.s3Multipart.key}`,
                },
              },
              hooks: {
                beforeError: [
                  error => {
                    const { response } = error;
                    if (response && response.body) {
                      error.name = 'Loading Error';
                      error.message = `${response.body.message} (${response.status})`;
                    }
                    console.log(error);
                    alert(error);
                  }
                ]
              },
              retry: 0
            });
            response.then((data) => {
              if (data.status == 200) {
                data.json().then((data) => {
                  console.log(data);
                })
              }
            });
          } catch (error) {
            console.log(error);
            alert(error);
          }
          // self.axios
          //   .post(
          //     `/api/v1/clients_files/${self.$route.params.id}`,
          //     {
          //       clients_files: {
          //         name: `${element.s3Multipart.key}`,
          //         url: `https://rentprog.storage.yandexcloud.net/${element.s3Multipart.key}`,
          //       },
          //     },
          //     {
          //       headers: {
          //         Authorization: self.$store.getters.getAuthToken,
          //       },
          //     }
          //   )
          //   .catch((error) => {
          //     this.setError(error, "Ошибка при загрузке файлов!");
          //   });
        }
      });
    });
    // const uppy = new Uppy({
    //   debug: true,
    //   autoProceed: true,
    //   restrictions: {
    //     maxFileSize: 1000000,
    //     maxNumberOfFiles: 1,
    //     minNumberOfFiles: 1,
    //     allowedFileTypes: ["image/*"]
    //   }
    // });

    // uppy.use(Dashboard, {
    //   inline: true,
    //   target: this.element,
    //   replaceTargetContent: true,
    //   showProgressDetails: true,
    //   note: "Images only, 1–10 files, up to 100 MB",
    //   height: 470,
    //   locale: {
    //     strings: {
    //       dropPaste: "Перетащите файлы сюда, перекиньте или %{browse}",
    //       browse: "выберите"
    //     }
    //   }
    // });

    // uppy.use(XHRUpload, {
    //   endpoint: "/api/v1/images",
    //   fieldName: "image[image]",
    //   formData: true,
    //   headers: {
    //     "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
    //   }
    // });

    // uppy.on("complete", result => {
    //   console.log("Upload complete! We’ve uploaded these files:", result.successful);
    // });
  }
}
